import { LanguageService } from '../LanguageService';
import Utils from '../Utils';
const {default: moment} = await import('moment')
/**
 * @namespace DateHelper 
 */
const DateHelper = {
    /**
     * @param {string } givenDate  Given date
     * @param {string } dateFormat  Date in string format
     * @param {string} locale optional locale parameter.
     * @returns {string} The formatted date string
     */
    async format(givenDate, dateFormat, lang = 'en') {
        const isValidDate = givenDate && (typeof givenDate === 'string' || givenDate instanceof String);
        const isValidFormat = dateFormat && (typeof dateFormat === 'string' || dateFormat instanceof String);
        if (isValidDate) {
            dateFormat = isValidFormat ? dateFormat : 'MMMM DD';
            const locale = LanguageService.getMomentLanguage(lang);
            return Utils.importMomentLanguages(locale).then(res => {
                try {
                    const date = moment(givenDate);
                    return date.isValid() ? date.locale(locale).format(dateFormat) : givenDate;
                } catch (error) {
                    return givenDate;
                }
            });
        } else {
            return "";
        }
    }
}
export default DateHelper;